import { Box, Button, Grid, Modal, TextField } from "@mui/material";
import axios from "axios";
import React, { useEffect } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { TRADE_MANAGE_RATE } from "../constant/endpoint";
import { getSweetAlert } from "../helper";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '40%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};

const ModalForRate = (props) => {
    const {match_id,_id} = props.data
    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState({});
    const [changeData, setChangeData] = React.useState({ option_id_1: 0, option_id_2: 10 });
    let search = window.location.search;
    let params = new URLSearchParams(search);
    const sport = params.get("sport")
    const handleClose = () => props.rateModal(false);
    useEffect(()=>{
        setOpen(true) 
        getRateData()
    },[])
    const getRateData = async () => {
        const response = await axios.get(TRADE_MANAGE_RATE.replace(':match_id',match_id).replace(':prediction_id',_id).replace("sport_id", sport))
        if(response?.data?.status === 'success'){
            setData(response?.data?.data)
        }
    }
    const optionHandle = (e) => {
        setChangeData({[e.target.name]:e.target.value, option_id_2: 10 - e.target.value})
    }
    const updateRateData = async () => {
        const formulaForA = (((changeData.option_id_1 * 10)/100)*40000)
        const formulaForB = (((changeData.option_id_2 * 10)/100)*40000)
        changeData.option_id_1 = formulaForA
        changeData.option_id_2 = formulaForB
        if(changeData.option_id_2 < 0 || changeData.option_id_1 < 0){
            getSweetAlert("error","Please enter value in positive")
        }else{
             const response = await axios.post(TRADE_MANAGE_RATE.replace(':match_id',match_id).replace(':prediction_id',_id).replace("sport_id",sport),changeData)
             if(response?.data?.status === 'success'){
                getSweetAlert("success","Rate change succesfully")
                props.rateModal(false)
             }
        }
    }
    return (
        <>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'Set'} Rate</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        <Grid xs={6} item>
                            <label>Update Option Yes</label>
                            <TextField id="outlined-basic" value={changeData?.option_id_1} type='number' size={'small'} variant="outlined" name={'option_id_1'}  onChange={optionHandle}/>
                        </Grid>
                        <Grid xs={6} item>
                            <label>Update Option  No</label>
                            <TextField id="outlined-basic" value={changeData?.option_id_2} type='number' size={'small'} variant="outlined" name={'option_id_2'} onChange={optionHandle} disabled/>
                        </Grid>
                        {
                            <>
                                <Grid xs={9} mt={2}>
                                    <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                                </Grid>
                                <Grid xs={3} mt={2} textAlign={'right'}>
                                    <Button onClick={updateRateData} variant="contained" >Submit</Button>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default ModalForRate